import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Bare application root — all chrome (sign-in, the admin shell) lives in routed components, mirroring
 * privaci-app's root. The former Angular CLI welcome page has been removed (FEAT-F1 / BUG-F1-1).
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
